export const identificationKeys = {
  all: ['identification'] as const,
  my: () => [...identificationKeys.all, 'my'] as const,
};
